export const checkRole = () => {
  const tokenJson = localStorage.getItem('ccAdmin.currentUser');
  if (tokenJson) {
    const token = JSON.parse(tokenJson).token;
    const decodedTokenJson = atob(token.split('.')[1]);
    return JSON.parse(decodedTokenJson).roles;
  }

  return null;
};